import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { useCheckRole } from "hooks";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { Button, Card, CardBody } from "reactstrap";
import { getCollectorById } from "./utils";
import Select from "react-select";
import { customFilter } from "react-bootstrap-table2-filter";
import { CUSTOM_SELECT_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import HubFilter from "components/shared-components/RemoteTable/HubFilter/HubFilter";
import { useNavigate } from "react-router-dom";
import useCustomHook from "./useCustomHook";
import ConfirmModal from "components/shared-components/ConfirmModal";
import AllocateCollectorDetail from "./AllocateCollectorDetail";
import ScheduleCollector from "./ListScheduleChangeCollector";
import PriorityScheduleModal from "pages/PrioritySchedule/PriorityScheduleModal";
const ListAllocateCollector = () => {
  const { t } = useTranslation(["allocateCollector", "prioritySchedule"]);
  const navigate = useNavigate();
  const { isLogAdmin } = useCheckRole();
  const [modalConfirmClear, setModalConfirmClear] = useState(false);
  const [isOpenDetail, setIsOpenDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState({ collectorId: "" });
  const [isOpenChangeSchedule, setIsOpenChangeSchedule] = useState(false);
  const [isOpenPrioritySchedule, setIsOpenPrioritySchedule] = useState(false);
  const togglePrioritySchedule = () => setIsOpenPrioritySchedule(prev => !prev);
  const [stateColumnFilter, setStateColumnFilter] = useState({
    route_id: undefined,
    timeslot_id: undefined,
  });

  const {
    allocateCollectorParams,
    setAllocateCollectorParams,
    listAllocateCollector,
    listCollectorUser,
    timeSlotCollector,
    routeCollector,
    timeslotParams,
    setTimeslotParams,
    routeParams,
    setRouteParams,
    isSelectAllHub,
    setIsSelectAllHub,
    listAllocateCollectorTableData,
    hubSchedule,
    isLoadingClear,
    handleClearSchedule,
  } = useCustomHook();

  const renderCollectors = (collectorArray, listCollectorUser) => {
    const result = [];
    if (listCollectorUser && listCollectorUser.length > 0) {
      collectorArray.forEach(item => {
        let collector = getCollectorById(item, listCollectorUser);
        collector &&
          result.push(
            <a onClick={() => onOpenDetail(collector)}>
              {collector.display_name}
            </a>
          );
      });
    }

    return result;
  };

  const toggleConfirmClearModal = () =>
    setModalConfirmClear(!modalConfirmClear);

  const toggleDetail = () => {
    setIsOpenDetail(!isOpenDetail);
  };

  const toggleChangeSchedule = () => {
    setIsOpenChangeSchedule(!isOpenChangeSchedule);
  };

  const onOpenDetail = collector => {
    setDataDetail({ collectorId: collector.id });
    toggleDetail();
  };
  const columnsTable = [
    {
      dataField: "mon",
      text: t("table.mon"),
      sort: false,
      allowExport: true,
      align: "center",
      formatter: (cell, row) => {
        return (
          row.days["mon"] &&
          renderCollectors(row.days["mon"], listCollectorUser?.items)
        );
      },
    },
    {
      dataField: "tue",
      text: t("table.tue"),
      sort: false,
      allowExport: true,
      align: "center",
      formatter: (cell, row) => {
        return (
          row.days["tue"] &&
          renderCollectors(row.days["tue"], listCollectorUser?.items)
        );
      },
    },
    {
      dataField: "wed",
      text: t("table.wed"),
      sort: false,
      allowExport: true,
      align: "center",
      formatter: (cell, row) => {
        return (
          row.days["wed"] &&
          renderCollectors(row.days["wed"], listCollectorUser?.items)
        );
      },
    },
    {
      dataField: "thu",
      text: t("table.thu"),
      sort: false,
      allowExport: true,
      align: "center",
      formatter: (cell, row) => {
        return (
          row.days["thu"] &&
          renderCollectors(row.days["thu"], listCollectorUser?.items)
        );
      },
    },
    {
      dataField: "fri",
      text: t("table.fri"),
      sort: false,
      align: "center",
      allowExport: true,
      formatter: (cell, row) => {
        return (
          row.days["fri"] &&
          renderCollectors(row.days["fri"], listCollectorUser?.items)
        );
      },
    },
    {
      dataField: "sat",
      text: t("table.sat"),
      sort: false,
      allowExport: true,
      align: "center",
      formatter: (cell, row) => {
        return (
          row.days["sat"] &&
          renderCollectors(row.days["sat"], listCollectorUser?.items)
        );
      },
    },
    {
      dataField: "sun",
      text: t("table.sun"),
      sort: false,
      allowExport: true,
      align: "center",
      formatter: (cell, row) => {
        return (
          row.days["sun"] &&
          renderCollectors(row.days["sun"], listCollectorUser?.items)
        );
      },
    },
    {
      dataField: "hub_id",
      text: "Center/Hub",
      sort: true,
      formatter: (cell, row) => row?.hub?.name,
    },
    {
      dataField: "timeslot_id",
      text: t("table.time_slot"),
      sort: false,
      allowExport: true,
      align: "center",
      formatter: (cell, row) => row?.timeSlot?.name,
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => {
        return (
          <div style={{ minWidth: "100px", fontWeight: "normal" }}>
            <Select
              isClearable
              placeholder={t("common:placeholder.select", {
                title: t("table.time_slot"),
              })}
              options={
                timeSlotCollector?.items?.map(item => ({
                  label: item.name,
                  value: item.id,
                })) || []
              }
              value={stateColumnFilter.timeslot_id}
              classNamePrefix="select2-selection"
              onChange={data => {
                setAllocateCollectorParams(prev => ({
                  ...prev,
                  columnFilter: {
                    ...prev.columnFilter,
                    "filter[timeslot_id]": data?.value || undefined,
                  },
                }));
                setStateColumnFilter(prev => ({
                  ...prev,
                  timeslot_id: data,
                }));
              }}
            />
          </div>
        );
      },
    },
    {
      dataField: "route_id",
      text: t("table.route_code"),
      sort: false,
      allowExport: true,
      align: "center",
      formatter: (cell, row) => row?.route?.map(item => item.name).join(", "),
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => {
        return (
          <div style={{ minWidth: "100px", fontWeight: "normal" }}>
            <Select
              isClearable
              placeholder={t("common:placeholder.select", {
                title: t("table.route_code"),
              })}
              value={stateColumnFilter.route_id}
              options={
                routeCollector?.items?.map(item => ({
                  label: item.name,
                  value: item.id,
                })) || []
              }
              classNamePrefix="select2-selection"
              onChange={data => {
                setAllocateCollectorParams(prev => ({
                  ...prev,
                  columnFilter: {
                    ...prev.columnFilter,
                    "filter[route_id]": data?.value || undefined,
                  },
                }));
                setStateColumnFilter(prev => ({
                  ...prev,
                  route_id: data,
                }));
              }}
            />
          </div>
        );
      },
    },
  ];
  const handleSelectHub = (hubIds, isSelectAll) => {
    setIsSelectAllHub(isSelectAll);
    const idFilter = hubIds.map(id => parseInt(id));
    setTimeslotParams(prev => ({
      ...prev,
      params: {
        ...prev.params,
        columnFilter: {
          ...prev.params.columnFilter,
          "filter[hub_id][in]": idFilter,
        },
      },
      run: true,
    }));
    setRouteParams(prev => ({
      ...prev,
      params: {
        ...prev.params,
        columnFilter: {
          ...prev.params.columnFilter,
          "filter[hub_id][in]": idFilter,
        },
      },
      run: true,
    }));
  };

  const listMultipleRowAction = [
    {
      icon: <i className="bx bx-calendar font-size-18 text-primary" />,
      text: t("table.even_week"),
      onClick: data => {
        setAllocateCollectorParams(prev => ({
          ...prev,
          columnFilter: { ...prev.columnFilter, "filter[is_odd_week]": 0 },
        }));
      },
    },
    {
      icon: <i className="bx bx-calendar font-size-18 text-primary" />,
      text: t("table.odd_week"),
      onClick: data => {
        setAllocateCollectorParams(prev => ({
          ...prev,
          columnFilter: { ...prev.columnFilter, "filter[is_odd_week]": 1 },
        }));
      },
    },
  ];

  return (
    <div className="page-content">
      <MetaTags ch>
        <title>{t("title.list")}</title>
      </MetaTags>
      <div className="container-fluid">
        <BreadcrumbWithLink
          title={`${t("title.list")} (${
            allocateCollectorParams?.columnFilter["filter[is_odd_week]"] === 1
              ? t("table.odd_week")
              : t("table.even_week")
          })`}
          breadcrumbItems={[
            { name: t("title.allocate_collector") },
            { name: t("title.list") },
          ]}
        />
        <Card>
          <CardBody>
            <RemoteDataTable
              keyField="id"
              data={listAllocateCollectorTableData}
              columns={columnsTable}
              page={1}
              sizePerPage={1}
              totalSize={0}
              isShowSearchIndex={false}
              isShowPagination={false}
              listMultipleRowAction={listMultipleRowAction}
            >
              <div className="d-flex gap-2">
                <HubFilter
                  mainFilterParams={allocateCollectorParams}
                  setMainFilterParams={setAllocateCollectorParams}
                  isNotFilterChildHub={true}
                  isHaveAllOption={true}
                  isFilterAllDefault={true}
                  handleSelectHub={handleSelectHub}
                />
               
                {isLogAdmin && (
                  <>
                    <Button
                      onClick={() => {
                        navigate(
                          { pathname: "/import-management/import" },
                          {
                            state: { isFocusTransport: true, code: 160 },
                          }
                        );
                      }}
                      color="primary"
                      className="btn-label"
                      type="button"
                    >
                      <i className="fas fa-file-upload me-2 label-icon " />
                      {t("title.import")}
                    </Button>
                    <Button
                      onClick={() => {
                        toggleChangeSchedule();
                      }}
                      color="success"
                      className="btn-label"
                      type="button"
                    >
                      <i className="bx bxs-calendar me-2 label-icon" />
                      Đổi lịch
                    </Button>
                    <Button
                      onClick={() => {
                        toggleConfirmClearModal();
                      }}
                      color="danger"
                      className="btn-label"
                      type="button"
                      disabled={!hubSchedule || isSelectAllHub}
                    >
                      <i className="bx bxs-trash me-2 label-icon" />
                      Clear lịch phân bổ collector
                    </Button>
                    <Button
                  onClick={togglePrioritySchedule}
                  color="warning"
                  className="btn-label"
                  type="button"
                >
                  <i className="bx bx-star me-2 label-icon" />
                  {t("prioritySchedule:button.open")}
                </Button>
                  </>
                )}
              </div>
            </RemoteDataTable>
            {/* Clear Modal */}
            <ConfirmModal
              isOpen={modalConfirmClear}
              titleHeader={
                <>
                  Xác nhận clear lịch phân bổ collector:{" "}
                  <span className="text-danger">
                    {hubSchedule?.is_center ? "Center" : "Hub"}{" "}
                    {hubSchedule?.name}
                  </span>
                </>
              }
              titleBody={"Hệ thống sẽ thực hiện clear lịch phân bổ collector ?"}
              isDisableButton={isLoadingClear}
              onConfirm={handleClearSchedule}
              textBtnConfirm={"Xác nhận"}
              textBtnCancel={"Đóng"}
              toggle={toggleConfirmClearModal}
            />

            <AllocateCollectorDetail
              isOpenModal={isOpenDetail}
              toggleModal={toggleDetail}
              dataDetail={dataDetail}
              hubIdFilter={
                allocateCollectorParams?.columnFilter["filter[hub_id][in]"]
              }
            />
            <ScheduleCollector
              isOpenModal={isOpenChangeSchedule}
              toggleModal={toggleChangeSchedule}
            />
            <PriorityScheduleModal
              isOpen={isOpenPrioritySchedule}
              toggle={togglePrioritySchedule}
              userType="collector"
            />
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default ListAllocateCollector;
